import { useIntl } from 'react-intl';

import { toastCaller } from '@/shared/ui';

export const useCopyToClipboard = () => {
  const { formatMessage } = useIntl();

  return async (value: string, successMessage?: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toastCaller({
        type: 'success',
        message:
          successMessage ??
          formatMessage({ id: 'global.copied', defaultMessage: 'Copied' }),
      });
    } catch {
      // clipboard can reject on insecure contexts; nothing actionable to show
    }
  };
};
